import { Permission } from "presentation/constant/ANAInfo/PermissionName";
import { ChargeWaiverProvider } from "presentation/store/ChargeWaiver/ChargeWaiverProvider";
import { ANAInfoWrapper } from "presentation/view/components/ANAInfo/ANAInfoWrapper";
import { MessageBarWrapper } from "presentation/view/components/MessageBarWrapper";
import { ChargeWaiverMDView } from "presentation/view/section/ChargeWaiver/ChargeWaiverMDView";
import { GridStyles } from "veronica-ui-component/dist/component/core/styled/table.styled";

const ChargeWaiverContMain = () => {
    return <ANAInfoWrapper permission={Permission.CHARGE_WAIVER}>
        <MessageBarWrapper>
            <ChargeWaiverProvider>
                <GridStyles/>
                <ChargeWaiverMDView/>
            </ChargeWaiverProvider>
        </MessageBarWrapper>
    </ANAInfoWrapper>
}

export default ChargeWaiverContMain;